"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaQuery = exports.sizes = exports.gutters = exports.margins = exports.columns = exports.breakpoints = void 0;
var styled_components_1 = require("styled-components");
exports.breakpoints = {
    XL: 960,
    L: 769,
    M: 560,
    S: 0,
};
exports.columns = {
    XL: 12,
    L: 8,
    M: 6,
    S: 4,
};
exports.margins = {
    XL: 4,
    L: 3.5,
    M: 3.5,
    S: 1,
};
exports.gutters = {
    XL: 1,
    L: 1,
    M: 1,
    S: 0.5,
};
exports.sizes = Object.keys(exports.breakpoints);
/**
 * Обертка над css-медиазапросами с заранее определенными брейкпоинтами.
 */
exports.mediaQuery = function (breakpoint, deviceScale) {
    if (deviceScale === void 0) { deviceScale = 2; }
    var index = exports.sizes.indexOf(breakpoint);
    var nextBreakpoint = exports.sizes[index - 1];
    var min = exports.breakpoints[breakpoint] > 0 ? exports.breakpoints[breakpoint] * deviceScale : null;
    var max = exports.breakpoints[nextBreakpoint] ? (exports.breakpoints[nextBreakpoint] - 1) * deviceScale : null;
    if (min === null && max !== null) {
        return function (content) {
            return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                @media (max-width: ", "px) {\n                    ", "\n                }\n            "], ["\n                @media (max-width: ", "px) {\n                    ", "\n                }\n            "])), max, content);
        };
    }
    if (min !== null && max !== null) {
        return function (content) {
            return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                @media screen and (min-width: ", "px) and (max-width: ", "px) {\n                    ", "\n                }\n            "], ["\n                @media screen and (min-width: ", "px) and (max-width: ", "px) {\n                    ", "\n                }\n            "])), min, max, content);
        };
    }
    return function (content) {
        return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            @media (min-width: ", "px) {\n                ", "\n            }\n        "], ["\n            @media (min-width: ", "px) {\n                ", "\n            }\n        "])), min, content);
    };
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=mediaQuery.js.map